<template>
    <div
        class="geo-autocomplete"
        id="geo-autocomplete">
        <my-input
            v-if="!isHome"
            ref="list_autocomplete"
            v-model="search"
            :label="lang.placeholders.geo_autocomplete"
            :disabled="autocomplete_disable"
            :autocomplete="false"
            @focus="onFocus"
            @input="autocomplete"
            @keyup.enter="selectResult"
            @keydown.down.capture.prevent.stop
            @keydown.up.capture.prevent.stop
            @keyup.down="chooseResult(1)"
            @keyup.up="chooseResult(-1)"
        />

        <!-- :placeholder="current_placeholder == null ? lang.placeholders.geo_autocomplete : current_placeholder" -->

        <input
            v-else
            v-model="search"
            type="text"
            class="form-control"
            :placeholder="lang.placeholders.geo_autocomplete"
            :autocomplete="false"
            @focus="onFocus"
            @input="autocomplete"
            @keyup.enter="selectResult"
            @keydown.down.capture.prevent.stop
            @keydown.up.capture.prevent.stop
            @keyup.down="chooseResult(1)"
            @keyup.up="chooseResult(-1)"
        >

        <div
            v-show="!isHome && show_badge"
            id="badge-autocomplete"
            class="badge-autocomplete"
            @click="resetSearch"
        >
            <div class="badge-autocomplete-text">
                <span v-html="current_placeholder" :title="current_placeholder"></span>
                <img src="/img/icons/close.svg" height="10" width="10" />
            </div>

            <div
                v-if="current_city && current_city.has_districts && section == 'estate'"
                class="badge badge-autocomplete-edit-districts"
                @click.stop.prevent="showDistricts"
            >
                {{ lang.labels.districts_selected }}
            </div>
        </div>

        <ul
            ref="geo_autocomplete_results"
            v-show="show_results"
            class="geo-autocomplete-results"
            @click.stop.prevent
        >
            <div class="geo-autocomplete-map"
                v-if="config_map.search_map && section == 'estate' && isHome"
                @click.stop.prevent
            >
                <li
                    v-if="section == 'estate' && isHome"
                    @click="geoLocate"
                >
                    <img :src="'/img/icons/' + $root.network + '/geo.svg'" class="geo" width="35" height="30"/>
                    <div>
                        <strong>{{ lang.labels.geo }}</strong>
                        <span class="action">{{ lang.labels.actions.geolocated }}</span>
                    </div>
                </li>

                <li
                    v-if="section == 'estate' && isHome"
                    @click="enableMapDraw('hand')"
                >
                    <img :src="'/img/icons/' + $root.network + '/draw-map.svg'" class="draw-map" width="26" height="26"/>
                    <div>
                        <strong>{{ lang.labels.draw_on_map }}</strong>
                        <span class="action">{{ lang.labels.actions.draw_on_map }}</span>
                    </div>
                </li>

                <li
                    v-if="section == 'estate' && isHome"
                    @click="enableMapDraw('circle')"
                >
                    <img :src="'/img/icons/' + $root.network + '/near-you.svg'" class="near-you" width="26" height="26" />
                    <div>
                        <strong>{{ lang.labels.close_to_you }}</strong>
                        <span class="action">{{ lang.labels.actions.close_to_you }}</span>
                    </div>
                </li>
            </div>

            <ul
                v-if="results_type == 'estate' && section == 'estate' && results.length"
                class="geo-autocomplete-section-geo"
            >
                <li class="geo-autocomplete-section-title">
                    {{ lang.section_title.estates|capitalize }}
                </li>

                <li
                    :id="'result_' + result.count"
                    v-for="result in results"
                    :key="result.id"
                    class="geo-result"
                    :class="(result.count == result_selected) ? 'selected' : ''"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>

            <ul v-if="results_type == 'geo' && results.precise" class="geo-autocomplete-section-geo">
                <li
                    :id="'result_' + result.count"
                    v-for="(result, index) in results.precise"
                    :key="index"
                    class="geo-result"
                    :class="'choose-' + (!result.show_districts ? result.type : 'district') + ' ' + ((result.count == result_selected) ? 'selected' : '')"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>
            
            <ul 
                v-if="results_type == 'geo' && results.provinces" 
                :class="'geo-autocomplete-section-geo ' + section"
            >
                <li
                    :class="'geo-autocomplete-section-title provinces ' + section"
                    @click.stop.prevent
                >
                    <img src="/img/icons/provinces.svg">
                    {{ lang.section_title.provinces|capitalize }}
                </li>

                <li
                    :id="'result_' + result.count"
                    v-for="result in results.provinces"
                    :key="result.id"
                    class="geo-result"
                    :class="(result.count == result_selected) ? 'selected' : ''"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>

            <ul v-if="results_type == 'geo' && results.cities" class="geo-autocomplete-section-geo">
                <li
                    class="geo-autocomplete-section-title cities"
                    @click.stop.prevent
                >
                    <img src="/img/icons/cities.svg">
                    {{ lang.section_title.cities|capitalize}}
                </li>

                <li
                    :id="'result_' + result.count"
                    v-for="result in results.cities"
                    :key="result.id + '_' + result.has_districts"
                    class="geo-result"
                    :class="(result.count == result_selected) ? 'selected' : ''"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>

            <ul v-if="results_type == 'geo' && results.districts" class="geo-autocomplete-section-geo">
                <li
                    class="geo-autocomplete-section-title districts"
                    @click.stop.prevent
                >
                    <img src="/img/icons/districts.svg">
                    {{ lang.section_title.districts|capitalize }}
                </li>

                <li
                    :id="'result_' + result.count"
                    v-for="result in results.districts"
                    :key="result.id"
                    class="geo-result"
                    :class="(result.count == result_selected) ? 'selected' : ''"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>

            <ul v-if="results_type == 'geo' && results.quarters" class="geo-autocomplete-section-geo">
                <li
                    class="geo-autocomplete-section-title districts"
                    @click.stop.prevent
                >
                    <img src="/img/icons/districts.svg">
                    {{ lang.section_title.quarters|capitalize }}
                </li>

                <li
                    :id="'result_' + result.count"
                    v-for="result in results.quarters"
                    :key="result.id"
                    class="geo-result"
                    :class="(result.count == result_selected) ? 'selected' : ''"
                    @click="setResult(result)"
                >
                    <span v-html="result.placeholder"></span>
                </li>
            </ul>
        </ul>

        <modal
            name="districts_list_modal"
            ref="districts_list_modal"
            extra-class="bottom-modal districts-list-modal"
        >
            <template slot="body">
                <keep-alive>
                    <districts-list
                        v-model="selectedDistricts"
                        :config="config"
                        :config_map="config_map"
                        :city="current_city"
                        :contract="contract"
                        :districts="districts"
                        :searchData="searchData"
                        :sector="sector"
                        :section="section"
                    />
                </keep-alive>
            </template>
        </modal>

        <tecno-map-drawer
            v-if="this.config_map.search_map"
            :contract="contract"
            :sector="sector"
            :section="section"
        />
    </div>
</template>

<script>
import DistrictsList from './DistrictsList'
import Modal from './Modal'
import TecnoMapDrawer from './maps/Drawer'

import { debounce } from 'lodash'

export default {
    components: {
        'districts-list': DistrictsList,
        'modal': Modal,
        'tecno-map-drawer': TecnoMapDrawer
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        contract: {
            type: String,
            default: null,
        },

        city: {
            type: Object,
            default: null,
        },

        districts: {
            type: Array,
            required: false,
        },

        // filters: {
        //     type: Object,
        //     required: true,
        // },

        isHome: {
            type: Boolean,
            default: false,
        },
        
        placeholder: {
            type: String,
            default: '',
        },

        searchData: {
            type: Object,
            required: false,
        },

        sector: {
            type: String,
            default: null,
        },

        section: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            autocomplete_disable: true,
            current_city: this.city,
            current_placeholder: this.placeholder,
            // districts: null,
            result_selected: null,
            results: [],
            results_type: '',
            results_count: 0,
            search: '',
            selectedDistricts: null,
            set_result: false,
            show_badge: true,
            show_results: false,
        }
    },

    computed: {
        firstResults() {
            return this.results.length ? this.results.slice(0, 6) : []
        },

        lang() {
            return this.$root.lang.geo_autocomplete
        },

        remainingResults() {
            return this.results.slice(6)
        },

        geolocation() {
            return (navigator.geolocation) ? true : false
        }
    },

    watch: {
        city(value) {
            this.current_city = value
        },
    },

    created() {
        this.watchClickOutside()

        // window.events.$on('update-search-placeholder', placeholder => {
        //     this.current_placeholder = placeholder
        // })

        window.events.$on('list.placeholder', placeholder => {
            if (placeholder)
                this.current_placeholder = placeholder
        })

        window.events.$on('has-districts-disable', () => {
            if (this.current_city) {
                this.current_city.has_districts = false
            }
        })

       window.events.$on('districts-have-been-hidden', () => {
            if (this.isHome) {
                this.current_placeholder = ''
                this.search = ''
            }
        })
    },

    mounted() {
        if (!this.current_placeholder) {
            this.current_placeholder = this.trans('labels.selected_area')
        }
    },

    methods: {
        noEvent() {
            alert("no!!!!!")
        },

        autocomplete: debounce(function(e) {
            if (e.keyCode == 13) return

            if (typeof e == 'object') {
                this.search = e.target.value
            }

            // if (this.section == 'estate' && this.config_map.search_map) {
            //     this.show_results = true
            // }

            // if (!this.search.length) {
            //     this.results = []

            //     return false
            // }

            if (this.search.length >= 3) {
                axios.get('/api/geo/autocomplete?search=' + this.search + '&section=' + this.section)
                    .then(({data}) => {
                        if (data.estates) {
                            this.results = data.estates
                            this.results_type = 'estate'
                        }
                        else if (data) {
                            this.show_results = (data.length == 0 && !this.isHome) ? false : true
                            this.results = data
                            this.results_type = 'geo'
                        }

                        this.results = this.results ?? []
                        if (this.section == 'construction' || (this.section == 'estate' && !this.config_map.search_map) || this.section == 'advertising') {
                            this.show_results = this.results.length != 0
                        }

                        this.setResultSelected(this.results)

                        this.$emit('geoList', this.results)
                    })
            } else {
                this.results = []
                this.result_selected = null
                if (!this.isHome || this.section == 'construction') {
                    this.show_results = false
                }
                // this.show_results = false
            }
        }, 400),

        onFocus() {
            this.showResults()

            this.$emit('focus')
        },

        setResult(result) {
            this.show_results = false
            
            this.current_placeholder = result.placeholder.replace(/<\/?[^>]+>/ig, '')

            this.search = (this.isHome) ? this.current_placeholder : ''

            this.show_badge = true

            result.results_type = this.results_type

            // if (result.has_districts ) {
            if (result.has_districts && (result.show_districts || this.config.districts_show)) {
                this.current_city = result

                this.showDistricts()
                return
            }
            else {
                this.current_city = result.type === 'city' ? result : null
            }

            this.set_result = true
            this.results = []
            
            window.events.$emit('update-save-search-disable', false)

            if (this.isHome) {
                isLoading()
            }

            this.$emit('input', result)
        },

        setResultSelected() {
            this.result_selected = 1

            this.results_count = 0

            if (this.results.precise) {
                for (const[key, value] of Object.entries(this.results.precise)) {
                    this.results_count++
                    this.results.precise[key]['count'] = this.results_count
                }
            }
            if (this.results.provinces) {
                for (const[key, value] of Object.entries(this.results.provinces)) {
                    this.results_count++
                    this.results.provinces[key]['count'] = this.results_count
                }
            }
            if (this.results.cities) {
                for (const[key, value] of Object.entries(this.results.cities)) {
                    this.results_count++
                    this.results.cities[key]['count'] = this.results_count
                }
            }
            if (this.results.districts) {
                for (const[key, value] of Object.entries(this.results.districts)) {
                    this.results_count++
                    this.results.districts[key]['count'] = this.results_count
                }
            }
            if (this.results[0]) {
                for (const[key, value] of Object.entries(this.results)) {
                    this.results_count++
                    this.results[key]['count'] = this.results_count
                }
            }
        },

        selectResult() {
            if (!!this.result_selected) {
                for (const[key, results] of Object.entries(this.results)) {
                    if (Array.isArray(results)) {
                        for (const[key2, result] of Object.entries(results)) {
                            if (result.count == this.result_selected) {
                                this.setResult(result)
                                if (!this.isHome) {
                                    this.$refs.list_autocomplete.$refs.input.blur()
                                }
                            }
                        }
                    } else {
                        if (results.count == this.result_selected) {
                            this.setResult(results)
                            if (!this.isHome) {
                                this.$refs.list_autocomplete.$refs.input.blur()
                            }
                        }
                    }
                }
            }
        },

        chooseResult(shift) {
            var selected = this.result_selected + shift

            if ((selected > 0) && (selected <= this.results_count)) {
                this.result_selected = selected

                var results_height = this.$refs['geo_autocomplete_results'].offsetHeight
                var results_top = this.$refs['geo_autocomplete_results'].scrollTop
                var results_bottom = results_top + results_height
                var selected_height = document.getElementById('result_' + this.result_selected).offsetHeight
                var selected_top = document.getElementById('result_' + this.result_selected).offsetTop
                var selected_bottom = selected_top + selected_height

                if ((shift == 1) && (selected_bottom >= results_bottom)) {
                    this.$refs['geo_autocomplete_results'].scroll(0, selected_bottom - results_height + 5)
                }

                if (shift == -1) {
                    if (this.result_selected == 1) {
                        this.$refs['geo_autocomplete_results'].scroll(0, 0)
                    }
                    else if (selected_top <= results_top) {
                        this.$refs['geo_autocomplete_results'].scroll(0, selected_top - 5)
                    }
                }
            }
        },

        showDistricts() {
            if (this.$root.is_mobile) {
                window.events.$emit('showModal', { name: 'districts_list_modal' })
            } else {
                this.$emit('show-districts', this.current_city)
            }
        },

        showResults() {
            if (this.section == 'estate' && this.config_map.search_map && (this.isHome || this.results.length != 0)) {
                this.show_results = true
            }
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                // if (this.show_results) {
                    let container = document.getElementById('geo-autocomplete')
                    let badge = document.getElementById('badge-autocomplete')

                    if (container) {
                        if (!container.contains(e.target) && !badge.contains(e.target)) {
                            this.show_results = false

                            if (!this.$root.is_mobile) {
                                this.show_badge = true
                            }
                        }
                    }
                // }
                
                if (!this.set_result) {
                    setTimeout(() => {
                        this.search = ''
                        this.results = []
                    }, 100)
                }
            })
        },

        enableMapDraw(mode) {
            window.events.$emit('Drawer.invoke', { mode: mode })
            this.show_results = false
        },

        geoLocate() {
            var geolocation_system_disable = true
            if (navigator.geolocation) {
                isLoading()
                this.show_results = false
                navigator.geolocation.getCurrentPosition(
                    position => {
                        geolocation_system_disable = false
                        axios.get('/api/geo-by-coords/' + position.coords.latitude + '/' + position.coords.longitude)
                        .then(({data}) => {
                            if (!data) {
                                stopLoading()
                                flash(this.lang.message.geolocation_noresult, 'warning')
                            } else {
                                var result = {
                                    'id': data.city_id,
                                    'type': 'city',
                                    'results_type': 'geo',
                                    'name': data.city_title,
                                    'placeholder': data.city_title + ' (' + this.lang.labels.city_all + ')',
                                    'province_id': data.province_id,
                                }

                                this.current_placeholder = result.placeholder.replace(/<\/?[^>]+>/ig, '')
                                this.$emit('input', result)
                            }
                        })
                        .catch(response => {
                            stopLoading()
                            flash(this.lang.message.geolocation_noresult, 'warning')
                        })
                    },
                    error => {
                        stopLoading()
                        flash(this.lang.message.geolocation_disable, 'warning')
                        return
                    },
                    {timeout: 6000}
                )
            } else {
                stopLoading()
                flash(lang.message.geolocation_error, 'warning')
                return
            }

            this.show_badge = true
        },

        resetSearch() {
            this.autocomplete_disable = false

            if (this.$root.is_mobile) {
                window.events.$emit('hideModal', { name: 'districts_list_modal' })
            } else {
                this.$emit('hide-districts')
            }

            window.events.$emit('districts.delete')

            this.$nextTick(() => {
                this.$refs.list_autocomplete.$refs.input.focus()
                this.$refs.list_autocomplete.$refs.input.value = ''

                this.show_badge = false
            })
        }
    },
}
</script>